<template>
  <div
    :class="['video-modal', { 'video-modal--new': newDesign }]"
    @click="closeVideoModal"
  >
    <div
      class="video-modal__inner"
      @click.stop
    >
      <button
        class="m-btn video-modal__close"
        @click="closeVideoModal"
      >
        <img
          :src="closeIconPath"
          alt="close"
        >
      </button>

      <iframe
        v-if="isYoutubeVideo"
        class="video-modal__video"
        :src="videoSrc"
        frameborder="0"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; web-share"
        allowfullscreen
      />
      <video
        v-else
        playsinline
        preload="none"
        class="video-modal__video"
        controls
        autoplay
      >
        <source
          v-for="(video, index) in videoSources"
          :key="index"
          :src="video"
          :type="`video/${getVideoType(video)}`"
        >
      </video>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'VideoModal',
  props: {
    closeIconPath: {
      type: String,
      default: '/v2/modal/close.svg',
    },
  },
  computed: {
    ...mapGetters('modals', {
      videoSrc: 'videoModalSrc',
    }),
    isYoutubeVideo() {
      if (Array.isArray(this.videoSrc)) {
        return false;
      }

      return this.videoSrc.includes('youtu');
    },
    videoSources() {
      if (Array.isArray(this.videoSrc)) {
        return this.videoSrc;
      }

      return [this.videoSrc];
    },
    newDesign() {
      const newDesignPages = ['index', 'online-school', 'school-university'];
      return newDesignPages.some((page) => this.$route.name.includes(page));
    },
  },
  methods: {
    ...mapActions('modals', {
      closeVideoModal: 'closeVideo',
    }),
    getVideoType(video) {
      if (!video) return 'mp4';

      const allVideoFormats = ['MP4', 'MOV', 'AVI', 'WMV', 'WEBM', 'MPEG', '3GP'];
      const videoSplitByDot = video.split('.');
      const videoFormat = videoSplitByDot.reverse()[0];

      if (allVideoFormats.includes(videoFormat.toUpperCase())) {
        return videoFormat;
      }

      return 'mp4';
    },
  },
};
</script>

<style scoped lang="scss">

.video-modal {
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba($white-color, 0.6);
  }

  .video-modal__inner {
    position: relative;
    z-index: 2;
    width: min(1070px, calc(100% - 32px));
    border-radius: 20px;
    border: 2px solid $black;
    box-shadow: 4px 4px 0 0 $black;
    background-color: $black-color;
    cursor: default;
    overflow: hidden;
  }

  .video-modal__close {
    position: absolute;
    z-index: 3;
    right: 20px;
    top: 20px;

    img {
      border-radius: 50px;
      border: 2px solid $black;
      background-color: $white-color;
      box-shadow: 2px 2px 0 0 $black;

      transition: 200ms;

      &:hover {
        box-shadow: none;
        //transform: translate(2px, 2px);
      }
    }
  }

  .video-modal__video {
    width: 100%;
    aspect-ratio: 16/9;
    object-fit: contain;
    background-color: $black-color;
    //height: 100%;
  }
}

.video-modal--new {
  z-index: 11;

  &:before {
    background-color: rgba( #02120F, 0.3);
    backdrop-filter: blur(5px);
  }

  .video-modal__inner {
    position: static;
    border-radius: calc(var(--scale) * 40);
    border: none;
    box-shadow: none;
    line-height: 0;

    @include media-down($size-tablet) {
      border-radius: calc(var(--scale) * 32);
    }
  }

  .video-modal__close {
    display: grid;
    place-content: center;
    right: calc(var(--scale) * 40);
    top: calc(var(--scale) * 30);
    width: calc(var(--scale) * 33);
    height: calc(var(--scale) * 33);
    background-color: #ECEDF0;
    border-radius: 50%;

    @include media-down($size-tablet) {
      right: calc(var(--scale) * 20);
      top: calc(var(--scale) * 15);
    }

    img {
      background-color: transparent;
      border: none;
      box-shadow: none;
      width: calc(var(--scale) * 16);
      height: calc(var(--scale) * 16);
      transform: none;
    }
  }
}

</style>
